export default "__VITE_ASSET__K4mJI6fY__"